import { useContext } from 'react'

import { Box } from '@material-ui/core'
import { makeStyles } from '@material-ui/core/styles'

import AcademicFocuses from 'components/ShareInterest/AcademicFocuses.tsx'

import ShareInterestContext from './ShareInterestProvider/Context'

const useStyles = makeStyles({
  autocompleteBox: {
    width: '100%',
  },
})

export const Interests = () => {
  const classes = useStyles()

  const { studentInterestInfo, updateStudentInterestInfo } = useContext(ShareInterestContext)
  const { academicFocuses } = studentInterestInfo || {}
  return (
    <Box className={classes.autocompleteBox}>
      <AcademicFocuses
        onUpdate={(data: string[]) => updateStudentInterestInfo('academicFocuses', data || [])}
        defaultAcademicFocus={academicFocuses}
      />
    </Box>
  )
}

export default Interests
